import CustomModal from "../../../../components/Modal/CustomModal";
import React from "react";
import ManageUsersModalApp from "../Requested/Functionality/ManageUsersModalApp";
import SearchSimple from "../../../../components/SearchSimples/SearchSimple";
import CustomTable from "../../../../components/table/CustomTable";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const ManageUsersModal = ({show, onHide, userClassificationSelected }) => {
    const {
        t, // Translation function
        pagination,
        setResults,
        rowsPerPage,
        searchElement,
        setSearchElement,
        setBodyForExport,
        setSimpleSearch,
        setSearch,
        tableId,
        searchId,
        thead,
        tbody,
        selectedList,
        getData
    } = ManageUsersModalApp({
        userClassificationSelected
    });
    return (
        <>
            <CustomModal
                show={show}
                title={t(userClassificationSelected?.titleTrans)}
                size='lg' // Modal size (large)
                buttonConfirm='confirm' // Text on the confirm button
                cancelButton={true} // Show cancel button
                confirmButton={false}
                onHide={() => {
                    onHide();
                }}
                onConfirm={() => {
                   onHide()
                }} // Function to call when the confirm button is clicked
            >

                <SearchSimple
                    id={"txt_mum_search"}
                    setSearchResults={setResults}
                    optionTable={userClassificationSelected?.model}
                    rowsPerPage={rowsPerPage}
                    searchElement={searchElement}
                    setSearchElement={setSearchElement}
                    setBodyForExport={setBodyForExport}
                    contractorId={null}
                    supplierId={null}
                    setSimpleSearch={setSimpleSearch}
                    setSearch={setSearch}
                    callApi={() => getData(0, { searchElement})}
                    resetApi={() => getData(0, {searchElement: ''})}
                />

                <CustomTable
                    tableId={tableId}
                    searchId={searchId}
                    checkbox={false}
                    thead={thead}
                    tbody={tbody}
                    columnActions={false}
                    selectedList={selectedList}
                    textNotInformation={"no_records_available"}
                    inModal={true}
                />

                {pagination()}
            </CustomModal>
        </>
    );
};

export default ManageUsersModal;
